import request from '@/utils/request'

export function pageNotices(params) {
  return request({
    url: '/course/notices/paging',
    method: 'get',
    params
  })
}

export function pageNewNotices(pageNum, pageSize, courseId) {
  return request({
    url: '/course/notices/new',
    method: 'get',
    params: { pageNum, pageSize, courseId }
  })
}

export function createNotice(data) {
  return request({
    url: '/course/notices',
    method: 'post',
    data
  })
}

export function updateNotice(id, data) {
  return request({
    url: `/course/notices/${id}`,
    method: 'put',
    data
  })
}

export function deleteNotice(id) {
  return request({
    url: `/course/notices/${id}`,
    method: 'delete'
  })
}
